// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".securitySettings-app .dnn-persona-bar-page-body .persona-bar-page-body {\n  min-height: 600px;\n}\n", "",{"version":3,"sources":["webpack://./src/less/style.less"],"names":[],"mappings":"AAAA;EACI,iBAAA;AACJ","sourcesContent":[".securitySettings-app .dnn-persona-bar-page-body .persona-bar-page-body{\n    min-height: 600px;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
